<template>
    <div class="main-settings campaign-step">
        <div class="step-header">
            <div class="step-icon">
                <img src="/images/settings.svg" alt="Настройки" />
            </div>
            <h2>{{ $t('messages.main_settings') }}</h2>
        </div>

        <div class="settings-content">
            <!-- Entity selectors: agency, advertiser category, advertiser, product -->
            <EntitySelectors :agencies="agencies" :categories="advertiser_categories" :advertisers="advertisers"
                :products="products" @update="onEntitiesUpdate" @created="onEntityCreated" :value="{
                    product_id: localData.product_id,
                    agency_id: localData.agency_id,
                    advertiser_id: localData.advertiser_id,
                    advertiser_category_id: localData.advertiser_category_id
                }" />

            <!-- Название кампании -->
            <CampaignName :value="localData.name" :is-test="localData.is_test" @input="updateName"
                @update:isTest="updateIsTest" />

            <!-- Статус -->
            <CampaignStatus :value="localData.status" @input="updateStatus" />

            <!-- Тип рекламы (removed) -->
        </div>
    </div>
</template>

<script>
import CampaignName from './MainSettings/CampaignName.vue';
import CampaignStatus from './MainSettings/CampaignStatus.vue';
import EntitySelectors from './MainSettings/EntitySelectors.vue';

export default {
    name: "MainSettings",
    components: {
        CampaignName,
        CampaignStatus,
        EntitySelectors,
        // creativeType component removed
    },
    props: {
        campaign: {
            type: Object,
            default: () => ({})
        },
        agencies: { type: Array, default: () => [] },
        advertiser_categories: { type: Array, default: () => [] },
        advertisers: { type: Array, default: () => [] },
        products: { type: Array, default: () => [] },
    },
    data() {
        return {
            localData: {
                name: '',
                status: 'active',
                is_test: false,
            }
        };
    },
    mounted() {
        // Инициализируем данные из пропса кампании
        if (this.campaign) {
            this.localData = {
                name: this.campaign.campaign || this.campaign.name || '',
                status: this.campaign.status || 'active',
                is_test: !!(this.campaign.is_test ?? this.campaign.isTest),
            };
            // initialize selected product if present on campaign
            if (this.campaign.product_id) {
                this.localData.product_id = this.campaign.product_id;
            }
            if (this.campaign.agency_id) {
                this.localData.agency_id = this.campaign.agency_id;
            }
            if (this.campaign.advertiser_id) {
                this.localData.advertiser_id = this.campaign.advertiser_id;
            }
            if (this.campaign.advertiser_category_id) {
                this.localData.advertiser_category_id = this.campaign.advertiser_category_id;
            }
        }
    },
    methods: {
        updateName(value) {
            if (typeof value === 'string') {
                this.localData.name = value;
                return;
            }
            const inputType = value?.target?.type;
            if (inputType === 'text' || inputType === 'search') {
                this.localData.name = value.target.value || '';
            }
        },

        updateStatus(value) {
            if (typeof value === 'string') {
                this.localData.status = value;
            }
        },

        updateIsTest(value) {
            this.localData.is_test = !!value;
        },

        onEntitiesUpdate(data) {
            // data: { product_id, advertiser_id, agency_id, advertiser_category_id }
            this.localData.product_id = data.product_id || null;
            this.localData.agency_id = data.agency_id || null;
            this.localData.advertiser_id = data.advertiser_id || null;
            this.localData.advertiser_category_id = data.advertiser_category_id || null;
        },

        onEntityCreated(payload) {
            // forward to parent so it can update available lists (props are read-only)
            this.$emit('created', payload);
        },

        // updateCreativeType removed
    },
    watch: {
        localData: {
            handler(newData) {
                this.$emit('update', newData);
            },
            deep: true
        }
    }
};
</script>